/* eslint-disable-next-line import/prefer-default-export */
export enum DisplayType {
    default = 'DEFAULT',
    warning = 'WARNING',
    error = 'ERROR',
    hint = 'HINT',
}
export interface NotificationMessage {
    text: string;
    autoHideIntervalSeconds?: number | 'sticky';
    displayType?: DisplayType;
    id: string;
}
